// import { Link } from 'react-router-dom';
// import { Col, Container, Row } from 'react-bootstrap';
// import FeatherIcon from 'feather-icons-react';

// // imgaes
// import logo from 'assets/images/logo.png';

// const Footer1 = () => {
//     const openPrivacyPolicy = () => {
//         const pdfPath = '/documents/Sales Trackify Privacy Policy.pdf';
//         window.open(pdfPath, '_blank');
//     };

//     const openTermsAndServices = () => {
//         const pdfPath = '/documents/Sales Trackify Terms of Service .pdf';
//         window.open(pdfPath, '_blank');
//     };

//     return (
//         <section className="mt-lg-5 pt-5 pb-4 bg-gradient6 position-relative">
//             <Container>
//                 <Row>
//                     <Col xl={4}>
//                         <Link className="navbar-brand me-lg-4 mb-4 me-auto d-flex align-items-center pt-0" to="#">
//                             <img src={logo} height="30" alt="" />
//                         </Link>
//                         <p className="text-muted w-75">
//                             Automate, Analyze, and Accelerate Your Business Growth
//                         </p>
//                     </Col>
//                     {/* <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-5">
//                             <h6 className="mb-3 mt-3 mt-sm-2 fs-14 fw-semibold text-uppercase"> Platform</h6>
//                             <ul className="list-unstyled">

//                                 <li className="my-3">
//                                     <Link to="#" className="text-muted">
//                                         Pricing
//                                     </Link>
//                                 </li>

//                             </ul>
//                         </div>
//                     </Col> */}
//                     <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-10">
//                             {/* <h6 className="mb-3 mt-3 mt-sm-2 fs-14 fw-semibold text-uppercase">Knowledge Base</h6>
//                             <ul className="list-unstyled">
//                                 <li className="my-3">
//                                     <Link to="#" className="text-muted">
//                                         Blog
//                                     </Link>
//                                 </li>

//                             </ul> */}
//                         </div>
//                     </Col>
//                     <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-8">

//                         </div>
//                     </Col>
//                     {/* <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-5">

//                         </div>
//                     </Col>
//                     <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-5">

//                         </div>
//                     </Col>
//                     <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-5">

//                         </div>
//                     </Col> */}
//                     <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-5">
//                             <h6 className="mb-3 mt-3 mt-sm-2 fs-14 fw-semibold text-uppercase">Company</h6>
//                             <ul className="list-unstyled">
//                                 <li className="my-3">
//                                     <a href="#home" className="text-muted">
//                                         Home
//                                     </a>
//                                 </li>

//                                 <li className="my-3">
//                                     <a href="#features" className="text-muted">
//                                         Features
//                                     </a>
//                                 </li>
//                                 <li className="my-3">
//                                     <a href="#about" className="text-muted">
//                                         About Us
//                                     </a>
//                                 </li>

//                                 <li className="my-3">
//                                     <a href="#contact" className="text-muted">
//                                         Contact Us
//                                     </a>
//                                 </li>

//                                 <li className="my-3">
//                                     <a href="#blogs" className="text-muted">
//                                         Blogs
//                                     </a>
//                                 </li>
//                             </ul>
//                         </div>
//                     </Col>
//                     <Col xl="auto" lg={3} xs={6}>
//                         <div className="ps-xl-5">
//                             <h6 className="mb-3 mt-3 mt-sm-2 fs-14 fw-semibold text-uppercase">Legal</h6>
//                             <ul className="list-unstyled">

//                                 <li className="my-3">
//                                     <Link to="#" className="text-muted" onClick={openPrivacyPolicy}>
//                                         Privacy Policy
//                                     </Link>
//                                 </li>
//                                 <li className="my-3">
//                                     <Link to="#" className="text-muted" onClick={openTermsAndServices}>
//                                         Terms of Service
//                                     </Link>
//                                 </li>

//                             </ul>
//                         </div>
//                     </Col>
//                 </Row>
//                 <hr />
//                 <Row className="text-md-start text-center">
//                     <Col md={8}>
//                         <p className="pb-0 mb-0 text-muted">
//                             {new Date().getFullYear()} © SalesTrackify. All rights reserved.{' '}
//                             <a href="https://corescripts.net/">CoreScripts Technologies</a>
//                         </p>
//                     </Col>
//                     <Col md={4} className="text-md-end">
//                         <div className="align-items-end mt-md-0 mt-4">
//                             <ul className="list-unstyled mb-0">
//                                 <li className="d-inline-block me-4">
//                                     <a href="https://www.facebook.com/salestrackify/"
//                                         className="text-primary fw-semibold ms-1"
//                                         target="_blank"
//                                         rel="noopener noreferrer">
//                                         <FeatherIcon icon="facebook" className="icon icon-xs" />
//                                     </a>
//                                 </li>

//                                 <li className="d-inline-block">
//                                     <a href="https://www.linkedin.com/company/salestrackify"
//                                         className="text-primary fw-semibold ms-1"
//                                         target="_blank"
//                                         rel="noopener noreferrer">
//                                         <FeatherIcon icon="linkedin" className="icon icon-xs" />
//                                     </a>
//                                 </li>
//                             </ul>
//                         </div>
//                     </Col>
//                 </Row>
//             </Container>
//         </section>
//     );
// };

// export default Footer1;




import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { useState } from 'react';

import logo from 'assets/images/logo.png';

const Footer1 = () => {
    const [email, setEmail] = useState("");

    const openPrivacyPolicy = () => {
        window.open('/documents/Sales Trackify Privacy Policy.pdf', '_blank');
    };

    const openTermsAndServices = () => {
        window.open('/documents/Sales Trackify Terms of Service .pdf', '_blank');
    };

    return (
        <footer
            style={{
                background: '#08172E',
                borderTopLeftRadius: "25px",
                borderTopRightRadius: "25px"
            }}
            className="pt-5 pb-4 text-white "
        >

            <Container>
                <Row className="gy-4">

                    {/* ===== LEFT LOGO AREA ===== */}
                    <Col lg={4}>
                        <div
                            className="bg-white rounded-pill d-flex justify-content-center align-items-center mb-3"
                            style={{
                                padding: "10px 20px",
                                width: "fit-content",
                                height: "fit-content"
                            }}       >
                            <img
                                src={logo}
                                height="30"
                                alt="logo"
                                className="d-block"
                                style={{ objectFit: "contain" }}
                            />
                        </div>


                        <p className="text-light opacity-75" style={{ maxWidth: '300px' }}>
                            SalesTrackify • Smart Sales & CRM Automation Platform
                        </p>

                        <div className="d-flex gap-3 mt-3">
                            <a
                                href="https://facebook.com/salestrackify"
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex justify-content-center align-items-center bg-white rounded-circle"
                                style={{ width: "40px", height: "40px" }}
                            >
                                <FeatherIcon icon="facebook" size={18} color="#08172E" />
                            </a>

                            <a
                                href="https://linkedin.com/company/salestrackify"
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex justify-content-center align-items-center bg-white rounded-circle"
                                style={{ width: "40px", height: "40px" }}
                            >
                                <FeatherIcon icon="linkedin" size={18} color="#08172E" />
                            </a>
                        </div>
                    </Col>

                    {/* ===== QUICK LINKS ===== */}
                    <Col lg={2} sm={6}>
                        <h6 className="fw-bold mb-3 text-light">Quick Links</h6>
                        <ul className="list-unstyled">
                            <li className="mb-2"><Link to="/about" className="text-light opacity-75">About Us</Link></li>
                            <li className="mb-2"><Link to="/features" className="text-light opacity-75">Features</Link></li>
                            <li className="mb-2"><Link to="/blogs" className="text-light opacity-75">Blog</Link></li>
                            <li className="mb-2"><Link to="/contact" className="text-light opacity-75">Contact Us</Link></li>
                        </ul>
                    </Col>

                    {/* ===== PRODUCTS =====*/}
                    <Col lg={2} sm={6}>
                        <h6 className="fw-bold mb-3 text-light">Legal</h6>
                        <ul className="list-unstyled hover">
                            <li className="mb-2"><Link to="/privacy" className="text-light opacity-75">Privacy Policy</Link></li>
                            <li className="mb-2"><Link to="/termsAndConditions" className="text-light opacity-75">Terms & Conditions</Link></li>

                        </ul>
                    </Col>


                    <Col lg={4}>
                        <h6 className="fw-bold mb-3 text-light">Company Info</h6>
                        {/* Company Name */}
                        <p className="text-light mb-1 opacity-75">
                            SalesTrackify — Smart Sales & CRM Platform
                        </p>

                        {/* Legal Entity */}
                        <div className="d-flex align-items-center text-light  mt-2">
                            <FeatherIcon icon="briefcase" size={16} color="#9E8CFF" className="me-2" />
                            <p className="mb-0" ><strong>CoreScripts Technologies Ltd</strong></p>
                        </div>

                        {/* Address */}
                        <div className="d-flex align-items-center  text-light mt-2 opacity-75">
                            <FeatherIcon icon="map-pin" color="#9E8CFF" size={16} className="me-2" />
                            <span>Rugby, UK</span>
                        </div>

                        {/* Phone */}
                        <div className="d-flex align-items-center mt-2 text-light opacity-75">
                            <FeatherIcon icon="phone" color="#9E8CFF" size={16} className="me-2" />
                            <span>+44 7775168068</span>
                        </div>

                        {/* Email */}
                        <div className="d-flex align-items-center mt-2 text-light opacity-75">
                            <FeatherIcon icon="mail" color="#9E8CFF" size={16} className="me-2" />
                            <span>hello@salestrackify.com</span>
                        </div>
                    </Col>
                </Row>

                <hr className="border-secondary opacity-25 mt-4" />

                {/* ===== BOTTOM BAR ===== */}
                <Row className="text-center text-md-start mb-1">
                    <Col md={6} className="text-light opacity-75">
                        © {new Date().getFullYear()} SalesTrackify. All Rights Reserved. <a className='text-light' href="https://corescriptstechnologies.co.uk/">CoreScripts Technologies</a>
                    </Col>

                </Row>
            </Container>
        </footer>
    );
};

export default Footer1;
